var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3867 8.49995C10.3867 9.81995 9.31999 10.8866 7.99999 10.8866C6.67999 10.8866 5.61333 9.81995 5.61333 8.49995C5.61333 7.17995 6.67999 6.11328 7.99999 6.11328C9.31999 6.11328 10.3867 7.17995 10.3867 8.49995Z",
    stroke: "#BBBCBD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.0133C10.3533 14.0133 12.5467 12.6266 14.0733 10.2266C14.6733 9.28665 14.6733 7.70665 14.0733 6.76665C12.5467 4.36665 10.3533 2.97998 8 2.97998C5.64667 2.97998 3.45334 4.36665 1.92667 6.76665C1.32667 7.70665 1.32667 9.28665 1.92667 10.2266C3.45334 12.6266 5.64667 14.0133 8 14.0133Z",
    stroke: "#BBBCBD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.060867cbf87775df70192b41c7dbf8aa.svg";
export { ForwardRef as ReactComponent };